import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { resetPassword } from '../utils/apiServices';
import '../stylesheets/login.css';

function ResetPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState('');
  const [loading, setLoading] = useState(false);
  const { uidb64, token } = useParams();
  const navigate = useNavigate();

  const handleNewPasswordChange = (event) => {
    setNewPassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  const validatePasswords = () => {
    if (newPassword.length < 8) {
      setErrors('La contraseña debe tener al menos 8 caracteres.');
      return false;
    }
    if (newPassword !== confirmPassword) {
      setErrors('Las contraseñas no coinciden.');
      return false;
    }
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!validatePasswords()) {
      setMessage('');
      return;
    }

    setLoading(true);
    try {
      await resetPassword(uidb64, token, newPassword);
      setMessage('Tu contraseña ha sido restablecida exitosamente. Puedes iniciar sesión con tu nueva contraseña.');
      setErrors('');
      setNewPassword('');
      setConfirmPassword('');
      
      // Redirigir al login después de 3 segundos
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error) {
      setErrors(error.response?.data?.detail || 'Ocurrió un error. Por favor, intenta nuevamente.');
      setMessage('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lineabase">
      <div className="auth-container">
        <div className="auth-column auth-info">
          <h2>Nueva Contraseña</h2>
          <p>Ingresa tu nueva contraseña. Debe tener al menos 8 caracteres para mayor seguridad.</p>
        </div>

        <div className="auth-column auth-form">
          <div className="document-check">
            <form onSubmit={handleSubmit} className="document-check-form">
              <label htmlFor="newPassword" className="form-label">Nueva Contraseña</label>
              <input
                type="password"
                id="newPassword"
                name="newPassword"
                value={newPassword}
                onChange={handleNewPasswordChange}
                required
                className="form-input"
                minLength="8"
                placeholder="Mínimo 8 caracteres"
                disabled={loading}
              />

              <label htmlFor="confirmPassword" className="form-label">Confirmar Nueva Contraseña</label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                required
                className="form-input"
                minLength="8"
                placeholder="Confirma tu contraseña"
                disabled={loading}
              />

              {errors && (
                <div className="error-container">
                  <p className="error-message">{errors}</p>
                </div>
              )}

              {message && (
                <div className="success-container">
                  <p className="success-message">{message}</p>
                </div>
              )}

              <button 
                type="submit" 
                className="form-submit-button"
                disabled={loading}
              >
                {loading ? 'Restableciendo...' : 'Restablecer Contraseña'}
              </button>
              
              <Link to="/login" className="form-toggle-button" style={{ textAlign: 'center', textDecoration: 'none' }}>
                Volver a Iniciar Sesión
              </Link>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword; 